"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onKeyDownHandler = void 0;
var onKeyDownHandler = function (e) {
    if (e.key !== 'Backspace' &&
        e.key !== 'Delete' &&
        (e.key < '0' || e.key > '9') &&
        e.key !== 'ArrowLeft' &&
        e.key !== 'ArrowRight') {
        e.preventDefault();
    }
};
exports.onKeyDownHandler = onKeyDownHandler;
